import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SigninComponent } from './signin/signin.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

import { BlankView } from '../views/blank/blank.view';
import { UnlockLoginComponent } from 'app/authentication/unlock-login/unlock-login.component';


const authenticationRoutes: Routes = [
    // login view
    {

        path: 'authentication', component: BlankView,
        children: [
            { path: '', component: SigninComponent },
            { path: 'signin', component: SigninComponent },
            { path: 'signin/:welcomeBack', component: SigninComponent },
            // handle all other routes
            { path: '**', component: SigninComponent }
        ],
    },
    {
        path: 'reset-password', component: BlankView,
        children: [
            { path: ':resetPasswordAuth', component: ResetPasswordComponent },
            { path: '**', component: ResetPasswordComponent }
        ]
    },
    {
        path: 'unlock-login', component: BlankView,
        children: [
            { path: ':unlockCode', component: UnlockLoginComponent },
            { path: '**', component: UnlockLoginComponent }
        ]
    }
];


@NgModule({
    imports: [RouterModule.forChild(authenticationRoutes)],
    exports: [RouterModule]
})
export class authenticationRoutingModule { }
